/**
 * Sets up global JavaScript error reporting.
 * If `jsErrorsEnabled` is enabled, an error handler is registered
 * to report JavaScript errors to a server endpoint.
 *
 * @param {string} contextPath - The context path of the application for constructing error report URLs.
 */
export function setupErrorReporting(contextPath: string): void {
	window.onerror = function (
		message: string | Event,
		source?: string,
		lineNumber?: number,
		columnNumber?: number,
		error?: Error,
	): boolean {
		fetch(`${contextPath}/jse`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				message,
				source,
				lineNumber,
				columnNumber,
				error: error ? JSON.stringify(error) : null,
			}),
		}).catch(() => {
			console.log('Error reporting failed');
		});
		return false; // Prevents the firing of the default event handler
	};
}
